"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unifiBlockchainProxyUrl = void 0;
const unifiBlockchainProxyUrl = (blockchain) => {
    return `https://proxy.unifiprotocol.com/rpc/${blockchain}`;
};
exports.unifiBlockchainProxyUrl = unifiBlockchainProxyUrl;
